<p-toast position="top-right"></p-toast>
<div class="p-g">
  <div class="p-g-12">
      <div class="p-g-12">
        <p-toolbar>
          <div class="p-toolbar-group-left p-toolbar-tecfolk-fix">
            <button (click)="save()" [disabled]="!NotificationForm.valid" pButton *ngIf="mode == 'add'" type="button"
              [label]='setLabel("saveBtnLabel")' icon="pi pi-save" class="p-button-success"></button>&nbsp;
            <button (click)="update()" [disabled]="!NotificationForm.valid" pButton *ngIf="mode == 'edit'"
              type="button" [label]='setLabel("updateBtnLabel")' icon="pi pi-save" class="p-button-success"></button>&nbsp;
          </div>
        </p-toolbar>
      </div>
      <p-tabView>
          <div class="card card-w-title">
            <div class="p-g-12">
              <form #NotificationForm="ngForm">
                <div class="p-g-6" style="text-align: left">
                  <h3 class="first">{{setLabel("notificationTitleLabel")}}</h3>
                  <div class="p-g p-fluid">
                    <div class="p-g-12">
                      <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-user" aria-hidden="true"></i></span>
                        <input type="text" pInputText [placeholder]='setLabel("notificationTitle*PlaceholderLabel")' name="title" #title="ngModel"
                          [(ngModel)]="Notification.title" required
                          [ngClass]="title.invalid && (title.dirty || title.touched) ? 'errorInput' : '' ">
                      </div>
                      <div *ngIf="title.invalid && (title.dirty || title.touched)">
                        <div *ngIf="title.errors.required" class="errorShow">
                          {{setLabel("titleRequiredLabel")}}
                        </div>
                        <!-- <div *ngIf="name.errors.pattern" class="errorShow">
                          Only Characters are Allowed.
                        </div> -->
                      </div>
                    </div>

                    <h3 class="first">{{setLabel("messageBodyLabel")}}</h3>
                    <div class="p-g-12">
                      <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-user" aria-hidden="true"></i></span>
                        <textarea type="string" [placeholder]='setLabel("messageBody*PlaceholderLabel")' pInputText #body="ngModel"
                          name="body" [(ngModel)]="Notification.body" rows="5" cols="30" required autocomplete="off"
                          [ngClass]="body.invalid && (body.dirty || body.touched) ? 'errorInput' : '' "></textarea>
                      </div>
                      <div *ngIf="body.invalid && (body.dirty || body.touched)">
                        <div *ngIf="body.errors.required" class="errorShow">
                          {{setLabel("messageBodyCorrectlyLabel")}}
                        </div>
                        <div *ngIf="body.errors.pattern" class="errorShow">
                          {{setLabel("messageBodyCorrectlyLabel")}}
                        </div>
                      </div>
                    </div>

                    <h3 class="first">{{setLabel("recurringLabel")}}</h3>
                    <div class="p-g-12">
                      <div class="p-inputgroup">
                        <p-inputSwitch #recurring="ngModel" name="recurring" [(ngModel)]="Notification.recurring"></p-inputSwitch>
                      </div>
                    </div>



                  </div>
                </div>

                <div class="p-g-6" style="text-align: left">
                  <h3 class="first">{{setLabel("selectDateLabel")}}</h3>
                    <div class="p-g-6 p-fluid">
                      <div class="p-g-12">
                        <div class="p-inputgroup">
                          <p-calendar
                              [ngClass]="scheduleDate.invalid && (scheduleDate.dirty || scheduleDate.touched) ? 'errorInput' : '' "
                              #scheduleDate="ngModel"
                              [required]="true"
                              name="scheduleDate"
                              [placeholder]='setLabel("selectDate&TimePlaceholderLabel")'
                              [(ngModel)]="Notification.scheduleDate"
                              inputId="time"
                              dateFormat="dd/mm/yy"
                              [showIcon]="true"
                              [showTime]="true"
                              hourFormat="12"
                          ></p-calendar>
                        </div>
                        <div *ngIf="scheduleDate.invalid && (scheduleDate.dirty || scheduleDate.touched)">
                          <div *ngIf="scheduleDate.errors.required" class="errorShow">
                            {{setLabel("dateAndTimeLabel")}}
                          </div>
                          <div *ngIf="scheduleDate.errors.pattern" class="errorShow">
                            {{setLabel("dateAndTimeLabel")}}
                          </div>
                        </div>
                      </div>

                      <h3 class="first" style="margin-top: 71px !important;">{{setLabel("sendToLabel")}}</h3>
                      <div class="p-g-12">
                        <div class="p-inputgroup p-fluid">
                        <p-multiSelect
                          class="p-inputgroup p-fluid"
                          [options]="sendingList"
                          [(ngModel)]="Notification.sendingTo"
                          name="sendingTo"
                          [required]="true"
                          defaultLabel="Send To"
                          #sendingTo="ngModel"
                          optionLabel="memberType"
                          display="chip"
                          [ngClass]="sendingTo.invalid && (sendingTo.dirty || sendingTo.touched) ? 'errorInput' : '' "
                          [selectedItemsLabel]="'{0} Type selected'"></p-multiSelect>
                        </div>
                        <div *ngIf="sendingTo.invalid && (sendingTo.dirty || sendingTo.touched)">
                          <div *ngIf="sendingTo.errors.required" class="errorShow">
                            {{setLabel("oneMemberTypeLabel")}}
                          </div>
                          <div *ngIf="sendingTo.errors.pattern" class="errorShow">
                           {{setLabel("oneMemberTypeLabel")}}
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
              </form>
            </div>
            <div style="clear: both;"></div>
          </div>
      </p-tabView>
  </div>
</div>
